import { measureText } from '@remotion/layout-utils';
import { FontStyle } from '../../items/text/text-item-type';
import { getTextDimensionsServer } from './measure-text-server';
import { turnFontStyleIntoCss } from './turn-font-style-into-css';

export const getTextDimensions = ({
  text,
  fontFamily,
  fontSize,
  lineHeight,
  letterSpacing,
  fontStyle,
}: {
  text: string;
  fontFamily: string;
  fontSize: number;
  lineHeight: number;
  letterSpacing: number;
  fontStyle: FontStyle;
}): { width: number; height: number } => {
  if (typeof document === 'undefined') {
    return getTextDimensionsServer({
      text,
      fontSize,
      fontFamily,
      lineHeight,
      letterSpacing,
      fontStyle,
    });
  }

  const { width } = measureText({
    text,
    fontSize,
    fontFamily,
    fontWeight: fontStyle.weight,
    additionalStyles: {
      lineHeight: String(lineHeight),
      display: 'inline',
      whiteSpace: 'pre',
      letterSpacing: `${letterSpacing}px`,
      ...turnFontStyleIntoCss(fontStyle),
    },
  });

  return {
    width: Math.ceil(width),
    height: Math.round(lineHeight * fontSize * text.split('\n').length),
  };
};
